<div class="services-title-bar" translate>{{ headerLabel }}</div>
	<button
		type="button"
		mat-button color="primary"
		class="services-label"
		[routerLink]="btnRouterLink">
		<span  class="widget-resize-double-line" translate>{{ btnLabel }}</span>
		<mat-icon iconPositionEnd class="service-icon copo-small-icon-button" svgIcon="plus_icon"></mat-icon>
	</button>